import { CampaignForm } from "@/partial/campaign/types";
import { Control, UseFormSetValue } from "react-hook-form";
import CustomerParameters from "./components/customer-parameters";
import LoanParameters from "./components/loan-parameters";
import { Divider, FilterAccounts } from "./styles";

interface FilterAccountsFormProps {
  isEdit: boolean;
  control: Control<CampaignForm>;
  setValue: UseFormSetValue<CampaignForm>;
}

export const FilterAccountsForm = ({
  isEdit,
  control,
  setValue,
}: FilterAccountsFormProps) => {
  return (
    <FilterAccounts>
      <CustomerParameters
        control={control}
        setValue={setValue}
        isEdit={isEdit}
      />
      <Divider />
      <LoanParameters control={control} setValue={setValue} isEdit={isEdit} />
    </FilterAccounts>
  );
};

export default FilterAccountsForm;
